
import { RichContent } from '@/modules/RichContent'
import { mapGetters } from 'vuex'

export default {
  name: 'Guarantee',
  components: {},
  props: {
    blok: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      style: this.blok.border_style,
      background: this.blok.bgcolor.color ? this.blok.bgcolor.color : '',
      borderRadius: this.blok.border_radius + 'px',
      paddingTop: this.blok.padding_top + 'px',
      paddingBottom: this.blok.padding_bottom + 'px'
    }
  },
  computed: {
    richContent: function() {
      return RichContent(this.blok.paragraph.content, {
        customer: this.$store.getters.customer(),
        pricing: this.$store.getters.pricing(this.$store.state.productId)
      })
    },
    borderStyle: function() {
      const borderColor = {
        border: '2px solid' + this.blok.border_color.color,
        background: this.background,
        borderRadius: this.borderRadius
      }
      return this.style ? borderColor : null
    },
    src() {
      const image = this.blok.image || {}
      const url = (image.filename || '').replace('https://a.storyblok.com', '')
      return `${url}/m/`
    }
  },
  ...mapGetters(['pricing', 'customer'])
}
